import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CurrencyFormat from 'react-currency-format';

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

import Filter from './filter';
import AccountNumberDasbor from './accountNumberDasbor';
import Piutang from './piutang';

import PulseLoader from "react-spinners/PulseLoader";
import { MonthlyEarning } from "./montly_earnings";
import { LatestTransaction } from "./latestTransaction";
import { LatestActivity } from "./latestActivity";

const Dashboard = props => {
  document.title = "Dashboard | Des Counts";
  const { data, loading } = useSelector(state => ({
    data: state.Dashboard.data,
    loading: state.Dashboard.loading,
  }));

  const onLihatPiutangCommand = () => {
    props.history.push('/piutang')
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />
          <Filter />

          <Row>
            <Col sm={3}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Total Transaction</p>
                      <h4 className="mb-0">
                        {!loading && <CurrencyFormat value={data?.totalTransaction ?? '-'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} displayType={'text'} />}
                        <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />
                      </h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-transfer font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm={6}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <Row>
                        <Col sm={6}>
                          <p className="text-muted fw-medium">Debit</p>
                          <h4 className="mb-0">
                            {!loading && <CurrencyFormat value={data?.totalDebit ?? '-'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} displayType={'text'} />}
                            <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />
                          </h4>
                        </Col>
                        <Col sm={6}>
                          <p className="text-muted fw-medium">Credit</p>
                          <h4 className="mb-0">
                            {!loading && <CurrencyFormat value={data?.totalCredit ?? '-'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} displayType={'text'} />}
                            <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />
                          </h4>
                        </Col>
                      </Row>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-dollar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm={3}>
              <MonthlyEarning />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm={8}>
              <LatestTransaction />
            </Col>
            <Col sm={4}>
              <LatestActivity />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <AccountNumberDasbor />
            </Col>
            <Col lg={6}>
              <Piutang onLihatPiutangCommand={onLihatPiutangCommand} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(Dashboard);
